import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const MobileMenuButton = ({ open, onToggle }) => (
  <Button variant="ghost" size="sm" onClick={onToggle} className="md:hidden p-2" data-testid="mobile-menu-toggle">
    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
  </Button>
);

export const MobileMenu = ({ open, links, actions, onClose }) => {
  if (!open) return null;
  return (
    <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-200 shadow-lg mobile-menu-enter z-50" data-testid="mobile-menu">
      <div className="px-6 py-4 space-y-3">
        {links.map((link, i) => (
          <Link key={i} to={link.to} onClick={onClose} className="block py-2 text-slate-700 font-medium hover:text-brand-blue">
            {link.label}
          </Link>
        ))}
        {actions && <div className="pt-3 border-t border-slate-100 space-y-2">{actions}</div>}
      </div>
    </div>
  );
};
